export enum OrderEntryType {
  Legacy = "Legacy",
  Current = "Current"
}
